import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AppProvider from './contexts/AppContext';
import AuthProvider from './contexts/AuthContext';
import NotificationProvider from './contexts/NotificationContext';
import AdminRoutes from './AdminRoutes';
import CompanyRoutes from './CompanyRoutes';

function App() {
    return (
        <AuthProvider>
            <AppProvider>
                <NotificationProvider>
                    <Router>
                        <Switch>
                            <Route path="/admin">
                                <AdminRoutes />
                            </Route>
                            <Route path="/company">
                                <CompanyRoutes />
                            </Route>
                        </Switch>
                    </Router>
                </NotificationProvider>
            </AppProvider>
        </AuthProvider>
    );
}

export default App;
